module.exports = __webpack_public_path__ + "static/media/If-you-snore.27fd2d6e.pdf";